import api from '../../api';

export default {
    namespaced: true,
    state: {
        forms: {},
        paths: {}
    },
    getters: {
        forms(state) {
            return state.forms;
        },
        paths(state) {
            return state.paths;
        },
        endOfPath: () => (path) => {
            return path.substr(path.lastIndexOf('/') + 1);
        },
        parentOfPath: () => (path) => {
            return path.substr(0, path.lastIndexOf('/'));
        },
        pathName: (state, getters) => path => {
            return decodeURIComponent(getters.endOfPath(path));
        }
    },
    mutations: {
        setForms(state, forms) {
            state.forms = forms;
        },
        setPaths(state, paths) {
            state.paths = paths;
        },
    },
    actions: {
        async load({ commit, rootGetters }, readOnly = false) {
            let user = rootGetters['user/user'];
            let forms = await api.get('forms', { drafts: !readOnly && user.hasRole('editor') ? 1 : 0 });
            let paths = await api.get('paths', { drafts: !readOnly && user.hasRole('editor') ? 1 : 0 });

            // Add/format some useful information for each loaded path
            for (let pathStr in paths) {
                const path = paths[pathStr];
                
                // Handle paths that reference a non-existant form (occurs when forms are hidden by service plan limit)
                if (path.form_template_id && !forms[path.form_template_id]) {
                    delete paths[pathStr];
                    continue;
                }

                let user = rootGetters['org/users'][path.created_by] || {};
                path.created_by_name = user.name_reversed;
                const lastUpdate = path.update_history[path.update_history.length - 1];
                path.updated_at = lastUpdate ? lastUpdate.updated_at : path.created_at;
                user = lastUpdate ? rootGetters['org/users'][lastUpdate.user_id] || {} : user;
                path.updated_by_name = user.name_reversed;
                if (!path.form_template_id) {
                    path.classes = 'far fa-folder-open';
                    path.title = 'Folder';
                } else if (forms[path.form_template_id].is_draft) {
                    path.classes = 'far fa-file-signature';
                    path.title = 'Draft form';
                } else {
                    path.classes = 'far fa-file-alt';
                    path.title = 'Published form';
                }
            }

            commit('setForms', forms);
            commit('setPaths', paths);
        },
        async pinPath({ dispatch, rootGetters }, path) {
            const pinnedPaths = rootGetters['user/user'].pinned_paths;
            if (pinnedPaths.indexOf(path) !== -1) return;

            const pinned = pinnedPaths.concat(path);
            await dispatch('user/save', { pinned_paths: pinned }, {root: true});
        },
        async unpinPath({ dispatch, rootGetters }, path) {
            const pinnedPaths = rootGetters['user/user'].pinned_paths;
            const index = pinnedPaths.indexOf(path);
            if (index === -1) return;

            const pinned = pinnedPaths.slice();
            pinned.splice(index, 1);
            await dispatch('user/save', { pinned_paths: pinned }, { root: true });
        },
    }
}